<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-12 09:51:22
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-24 16:39:59
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\goodsInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="flex-row-align-center">
			<rdText> {{ row.activityName }} </rdText>
			<ID-tag class="ml-4" label="活动ID" :id="row.outerActivityId" />
		</div>
		<div class="yx-color-text-secondary font-h6-regular"> 推广有效期：{{ row.promotionEndTime | formatEmpty }} </div>
		<div class="yx-color-text-secondary font-h6-regular"> 团长保护期：{{ row.authorityProtectionPeriod | formatEmpty }} </div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import IDTag from '@/components/ui/IDTag';
export default {
	components: {
		IDTag,
	},
	mixins: [mixin],
	data() {
		return {};
	},
	methods: {},
};
</script>
<style lang="less" scoped>
</style>